import { InnerQueryExpression } from "../InnerQueryExpression";

export class CountCallExpression implements InnerQueryExpression {
    public readonly $discriminator = "CountCall";
    public readonly argument?: InnerQueryExpression;

    public constructor(argument?: InnerQueryExpression) {
        this.argument = argument;
    }
}
